import React, { useEffect } from 'react';
import { Button, Form, Grid, Image, Modal } from 'semantic-ui-react';
import { SelectField, TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import * as moment from 'moment-timezone';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import { listingValidationSchema } from '../adslot.constants';
import FirmDropDown from '../FirmDropDown';
import CloudinaryUploadWidget from '../CloudinaryUploadWidget';
import { DateTimeInput } from 'semantic-ui-calendar-react';

const EditListingModal = ({ trigger, updateListing, getRepsForFirm, typeOptions, item, reps, user }) => {
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    if (!open) return;
    getRepsForFirm(item.showcaseFirmId);
  }, [open]);

  const handleSubmit = (listing, formik) => {
    updateListing(listing);
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Formik
      key={item.id}
      initialValues={item}
      enableReinitialize
      validationSchema={listingValidationSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal size="large" onClose={() => setOpen(false)} onOpen={() => setOpen(true)} open={open} trigger={trigger}>
          <Modal.Header style={{ padding: 10, paddingLeft: 20 }}>Edit Listing</Modal.Header>
          <Modal.Content image>
            {formik.values.imageUrl && <Image size="medium" src={formik.values.imageUrl} wrapped />}
            <Modal.Description style={{ width: '90%' }}>
              <Form onSubmit={formik.handleSubmit} widths="equal" style={{ paddingRight: '2rem' }} size="tiny">
                <Form.Group inline>
                  <FirmDropDown
                    name="showcaseFirmId"
                    label="Firm"
                    formik={formik}
                    value={formik.values.showcaseFirmId}
                    onChange={formik.handleChange}
                    error={formik.touched.showcaseFirmId && Boolean(formik.errors.showcaseFirmId)}
                    errorMessage={formik.errors.showcaseFirmId}
                  />
                  <SelectField
                    name="type"
                    options={typeOptions}
                    onChange={formik.handleChange}
                    value={formik.values.type}
                    label="Type"
                    formik={formik}
                  />
                </Form.Group>

                {formik.values.type !== 'Product' && (
                  <>
                    <SelectField
                      name="representativeId"
                      options={reps}
                      onChange={formik.handleChange}
                      value={formik.values.representativeId}
                      label="Realtor"
                      formik={formik}
                    />

                    <Form.Group>
                      <Form.Field>
                        <label>Open House Start Date & Time</label>
                        <DateTimeInput
                          name="openHouseStartDate"
                          value={
                            formik?.values?.openHouseStartDate
                              ? moment(formik.values.openHouseStartDate).format('LLLL')
                              : ''
                          }
                          iconPosition="left"
                          dateFormat="LLLL"
                          onChange={(e, { value }) => formik.setFieldValue('openHouseStartDate', moment(value, 'LLLL'))}
                        />
                      </Form.Field>

                      <Form.Field>
                        <label>Open House End Date & Time</label>
                        <DateTimeInput
                          name="openHouseEndDate"
                          value={
                            formik?.values?.openHouseEndDate
                              ? moment(formik.values.openHouseEndDate).format('LLLL')
                              : ''
                          }
                          iconPosition="left"
                          dateFormat="LLLL"
                          onChange={(e, { value }) => formik.setFieldValue('openHouseEndDate', moment(value, 'LLLL'))}
                        />
                      </Form.Field>
                    </Form.Group>
                  </>
                )}

                <Form.Group>
                  <TextField
                    name="description1"
                    formik={formik}
                    value={formik.values.description1}
                    onChange={formik.handleChange}
                    error={formik.touched.description1 && Boolean(formik.errors.description1)}
                    errorMessage={formik.errors.description1}
                    label="Description 1"
                  />
                  <TextField
                    name="description2"
                    formik={formik}
                    value={formik.values.description2}
                    onChange={formik.handleChange}
                    error={formik.touched.description2 && Boolean(formik.errors.description2)}
                    errorMessage={formik.errors.description2}
                    label="Description 2"
                  />
                </Form.Group>

                <Form.Group>
                  <TextField
                    name="url"
                    formik={formik}
                    value={formik.values.url || ' '}
                    onChange={formik.handleChange}
                    error={formik.touched.url && Boolean(formik.errors.url)}
                    errorMessage={formik.errors.url}
                    label="URL"
                  />

                  <Form.Field>
                    <Grid columns="2" style={{ marginBottom: 0 }}>
                      <Grid.Column width="12">
                        <TextField
                          name="imageUrl"
                          formik={formik}
                          value={formik.values.imageUrl}
                          onChange={formik.handleChange}
                          error={formik.touched.imageUrl && Boolean(formik.errors.imageUrl)}
                          errorMessage={formik.errors.imageUrl}
                          label="Image"
                        />
                      </Grid.Column>
                      <Grid.Column style={{ paddingTop: 37 }} width="4">
                        <CloudinaryUploadWidget formik={formik} fieldName={'imageUrl'} />
                      </Grid.Column>
                    </Grid>
                  </Form.Field>
                </Form.Group>

                {formik.values.type === 'Product' && (
                  <>
                    <TextField
                      name="line1"
                      formik={formik}
                      value={formik.values.line1}
                      onChange={formik.handleChange}
                      error={formik.touched.line1 && Boolean(formik.errors.line1)}
                      errorMessage={formik.errors.line1}
                      label="Line 1"
                    />

                    <TextField
                      name="line2"
                      formik={formik}
                      value={formik.values.line2}
                      onChange={formik.handleChange}
                      error={formik.touched.line2 && Boolean(formik.errors.line2)}
                      errorMessage={formik.errors.line2}
                      label="Line 2"
                    />

                    <TextField
                      name="line3"
                      formik={formik}
                      value={formik.values.line3}
                      onChange={formik.handleChange}
                      error={formik.touched.line3 && Boolean(formik.errors.line3)}
                      errorMessage={formik.errors.line3}
                      label="Line 3"
                    />
                  </>
                )}

                <TextField
                  name="price"
                  formik={formik}
                  value={formik.values.price}
                  onChange={formik.handleChange}
                  error={formik.touched.price && Boolean(formik.errors.price)}
                  errorMessage={formik.errors.price}
                  label="Price"
                />

                {formik.values.type !== 'Product' && (
                  <>
                    <Form.Group>
                      <TextField
                        name="address"
                        formik={formik}
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        error={formik.touched.address && Boolean(formik.errors.address)}
                        errorMessage={formik.errors.address}
                        label="Address"
                      />
                      <TextField
                        name="city"
                        formik={formik}
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        error={formik.touched.city && Boolean(formik.errors.city)}
                        errorMessage={formik.errors.city}
                        label="City"
                      />
                    </Form.Group>

                    <Form.Group>
                      <TextField
                        name="state"
                        formik={formik}
                        value={formik.values.state}
                        onChange={formik.handleChange}
                        error={formik.touched.state && Boolean(formik.errors.state)}
                        errorMessage={formik.errors.state}
                        label="State"
                      />
                      <TextField
                        name="zip"
                        formik={formik}
                        value={formik.values.zip}
                        onChange={formik.handleChange}
                        error={formik.touched.zip && Boolean(formik.errors.zip)}
                        errorMessage={formik.errors.zip}
                        label="Zip"
                      />
                    </Form.Group>
                  </>
                )}
              </Form>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)} size="tiny">
              Cancel
            </Button>

            {user.isAdmin && (
              <Button
                negative
                size="tiny"
                onClick={() => {
                  formik.setFieldValue('isDeleted', true);
                  formik.handleSubmit();
                }}
              >
                Delete
              </Button>
            )}
            <Button content="Save" onClick={formik.handleSubmit} positive size="tiny" />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  reps: selectors.reps.repOptions(state),
  typeOptions: selectors.getTypeOptions(state),
  user: selectors.getUser(state),
});

const mapDispatchToProps = dispatch => ({
  getFirms: bindActionCreators(actions.firm.getFirms, dispatch),
  getRepsForFirm: bindActionCreators(actions.rep.getRepsForFirm, dispatch),
  updateListing: bindActionCreators(actions.listing.updateListing, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditListingModal);
